export var Widget;
(function (Widget) {
    /** 14dbefb9-3b7b-c4e9-53e8-766defd30587 */
    Widget["ABOUT"] = "ABOUT";
    /** 14dd1af6-3e02-63db-0ef2-72fbc7cc3136 */
    Widget["MY_ACCOUNT"] = "MY_ACCOUNT";
    /** c85a2896-9f7c-4cf1-9bf8-95852cc5219a */
    Widget["MY_REWARDS"] = "MY_REWARDS";
    /** e018cc55-7b1c-4500-a2e5-969f22c8a33a */
    Widget["GROUPS"] = "GROUPS";
    /** 14f0266c-e0a3-afc6-d07c-5be8e20949cd */
    Widget["FORUM_POSTS"] = "FORUM_POSTS";
    /** 14f51b00-3ada-272e-b6db-34d5da9dd623 */
    Widget["FORUM_COMMENTS"] = "FORUM_COMMENTS";
    /** 405eb115-a694-4e2b-abaa-e4762808bb93 */
    Widget["EVENTS"] = "EVENTS";
    /** 14ebe825-b273-0d5f-0fd1-e6293322b83b */
    Widget["FOLLOWING_FOLLOWERS"] = "FOLLOWING_FOLLOWERS";
    /** a26fd26a-3dd9-42ca-b381-326a9c143e38 */
    Widget["FOLLOWING_FOLLOWERS_LIGHTBOX"] = "FOLLOWING_FOLLOWERS_LIGHTBOX";
    /** 14f260f9-c2eb-50e8-9b3c-4d21861fe58f */
    Widget["BLOG_COMMENTS"] = "BLOG_COMMENTS";
    /** 14f26109-514f-f9a8-9b3c-4d21861fe58f */
    Widget["BLOG_LIKES"] = "BLOG_LIKES";
    /** 14f26118-b65b-b1c1-b6db-34d5da9dd623 */
    Widget["BLOG_POSTS"] = "BLOG_POSTS";
    /** 14f260e4-ea13-f861-b0ba-4577df99b961 */
    Widget["BLOG_DRAFTS"] = "BLOG_DRAFTS";
    /** e5a2773b-0e6b-4cbb-a012-3b4a69e92046 */
    Widget["MY_POSTS"] = "MY_POSTS";
    /** 384628b7-c716-4410-8fc5-4e2bd5aad178 */
    Widget["MY_CHALLENGES"] = "MY_CHALLENGES";
    /** c88902a1-7fbf-4ff1-b19a-af39c48bc740 */
    Widget["MY_PROGRAMS"] = "MY_PROGRAMS";
    /** b29db04a-a8f2-4bfe-bbad-21c99c1054b5 */
    Widget["MY_SUBSCRIPTIONS"] = "MY_SUBSCRIPTIONS";
    /** 14edb332-fdb9-2fe6-0fd1-e6293322b83b */
    Widget["MY_BOOKINGS"] = "MY_BOOKINGS";
    /** 14f2595a-a352-3ff1-9b3c-4d21861fe58f */
    Widget["NOTIFICATIONS"] = "NOTIFICATIONS";
    /** 14f25dd2-f9b0-edc2-f38e-eded5da094aa */
    Widget["SETTINGS"] = "SETTINGS";
    /** 151290e1-62a2-0775-6fbc-02182fad5dec */
    Widget["MY_ADDRESSES"] = "MY_ADDRESSES";
    /** 14e121c8-00a3-f7cc-6156-2c82a2ba8fcb */
    Widget["MY_ORDERS"] = "MY_ORDERS";
    /** 6467c15e-af3c-4e8d-b167-41bfb8efc32a */
    Widget["MY_WALLET"] = "MY_WALLET";
    /** 11b7884b-eba1-4a47-b5c8-7afb395f966a */
    Widget["SHARED_GALLERY"] = "SHARED_GALLERY";
    /** 35a4cb97-c8cd-4ee9-ac3c-89c13c8493d6 */
    Widget["FILE_SHARE"] = "FILE_SHARE";
    /** eed51e05-c783-4506-9fb3-0f5c47d6dea2 */
    Widget["TEST_PUBLIC"] = "TEST_PUBLIC";
    /** cc87eeb5-95a9-4f49-b7c3-5246eb39fee0 */
    Widget["TEST_PRIVATE"] = "TEST_PRIVATE";
    /** a63a5215-8aa6-42af-96b1-583bfd74cff5 */
    Widget["MY_WISHLIST"] = "MY_WISHLIST";
    /** 14cefc05-d163-dbb7-e4ec-cd4f2c4d6ddd */
    Widget["PROFILE_CARD"] = "PROFILE_CARD";
    /** 596a6688-3ad7-46f7-bb9c-00023225876d */
    Widget["MEMBER_PAGE"] = "MEMBER_PAGE";
    /** 2f6c5608-393f-4b15-bfd8-d4e15396787a */
    Widget["SETTINGS_PAGE"] = "SETTINGS_PAGE";
})(Widget || (Widget = {}));
//# sourceMappingURL=types.impl.js.map